/// <reference path="../types/index.d.ts" />

import '../client_forms/culinaryteam2/style.css';
import FormStructure from './culinaryteam2/form_structure';

export default FormStructure;